export class Model {
    constructor(data, events) {
        this.events = events;
        Object.assign(this, data);
    }
    emitChanges(event, payload) {
        this.events.emit(event, payload !== null && payload !== void 0 ? payload : {});
    }
}
